import uuid from 'react-native-uuid';
import { create } from "zustand";

const INITIAL_STATE = {
    items: [],
    props: {
        zIndex: 1200,
    }
}

export const useToasty = create((set) => ({

    items: INITIAL_STATE.items,
    props: INITIAL_STATE.props,
    
    setProps: (props) => set({props}),
    updateProps: (props) => set(prev => ({props: {...prev.props, ...props}})),
    resetProps: () => set({props: INITIAL_STATE.props}),
    
    push: (item) => set(prev => ({items: [...prev.items, {id: uuid.v4(), ...item}]})),
    success: (message) => set(prev => ({items: [...prev.items, {id: uuid.v4(), message, type: 'success'}]})),
    error: (message) => set(prev => ({items: [...prev.items, {id: uuid.v4(), message, type: 'error'}]})),
    info: (message) => set(prev => ({items: [...prev.items, {id: uuid.v4(), message, type: 'info'}]})),
    warning: (message) => set(prev => ({items: [...prev.items, {id: uuid.v4(), message, type: 'warning'}]})),
    addProduct: (message) => set(prev => ({items: [...prev.items, {id: uuid.v4(), message, type: 'addProduct'}]})),
    
    hide: (id = null) => {
        if (id == null) {
            set({items: []});
            return;
        }

        set(prev => ({items: prev.items?.filter(item => item.id !== id)}));
    },

    reset: () => set(INITIAL_STATE),

}));